import { PM_PROVIDERS } from 'common/constants/constants';

const FILTER_TYPES = {
  BOARD: 'board',
  ISSUE_TYPES: 'issueTypes',
  EPIC: 'epic',
  LABEL: 'label',
  FIELD: 'field',
  PROJECTS: 'projects',
  TEAMS: 'teams',
  FIX_VERSION: 'fixVersion',
  SHORTCUT_LABEL: 'shortcutLabels',
  SHORTCUT_EPICS: 'shortcutEpics',
  STATUSES: 'jiraState',
  ORGANIZATION_TEAMS: 'team'
};

const LINB_STATUS_CATEGORIES_NAMES = {
  TO_DO: 'To Do',
  IN_PROGRESS: 'In Progress',
  DONE: 'Done'
};

export const LINB_STATUS_CATEGORIES_KEYS = {
  CREATED: 'created',
  IN_PROGRESS: 'in-progress',
  DONE: 'done'
};

export const JIRA_STATE_CATEGORIES_KEYS = {
  NEW: 'new',
  INDETERMINATE: 'indeterminate',
  DONE: 'done'
};

export const PM_STATES_CATEGORIES_NAMES_MAPPER = {
  indeterminate: LINB_STATUS_CATEGORIES_NAMES.IN_PROGRESS,
  new: LINB_STATUS_CATEGORIES_NAMES.TO_DO,
  done: LINB_STATUS_CATEGORIES_NAMES.DONE
};

export const PM_STATES_CATEGORIES_MAPPER = {
  indeterminate: LINB_STATUS_CATEGORIES_KEYS.IN_PROGRESS,
  new: LINB_STATUS_CATEGORIES_KEYS.CREATED,
  done: LINB_STATUS_CATEGORIES_KEYS.DONE
};

export const PM_STATES_TO_JIRA_STATES_MAPPER = {
  [LINB_STATUS_CATEGORIES_KEYS.IN_PROGRESS]:
    JIRA_STATE_CATEGORIES_KEYS.INDETERMINATE,
  [LINB_STATUS_CATEGORIES_KEYS.CREATED]: JIRA_STATE_CATEGORIES_KEYS.NEW,
  [LINB_STATUS_CATEGORIES_KEYS.DONE]: JIRA_STATE_CATEGORIES_KEYS.DONE
};

export const ISSUE_STATES_INFO_TEXTS = {
  [LINB_STATUS_CATEGORIES_KEYS.CREATED]: (
    <span>
      Displays all issues matching your criteria which were created (To Do)
      during each time frame.
    </span>
  ),
  [LINB_STATUS_CATEGORIES_KEYS.IN_PROGRESS]: (
    <span>
      Displays issues which were in this state at any time during this time
      frame.
    </span>
  ),
  [LINB_STATUS_CATEGORIES_KEYS.DONE]: (
    <span>
      Displays all issues that transitioned to <b>and</b> remained in the "Done"
      state through the end of each time frame.
    </span>
  )
};

export const ONLY_INCLUDE_CREATED_VALUE = 'created';
export const INCLUDE_ALL_ISSUES_VALUE = 'all';

export const ISSUE_INCLUSION_OPTIONS = [
  { name: 'All items', value: INCLUDE_ALL_ISSUES_VALUE },
  { name: 'Only created items', value: ONLY_INCLUDE_CREATED_VALUE }
];

export const TRANSITION_STRATEGY = {
  STATE: 'state',
  CATEGORY: 'category'
};

// TODO: use FILTER_TYPES_V2 when creating
export const CUSTOM_FIELDS_KEY = 'fields';
export const ISSUE_TYPES_KEY = 'issue_types';
export const ISSUE_STATES_KEY = 'issue_states';
export const STATE_TRANSITIONS_KEY = 'state_transitions';
export const IS_ALL_ISSUE_TYPES_SELECTED_KEY = 'is_all_issue_types_selected';

export const FilterTypesWithoutFields = [
  FILTER_TYPES.BOARD,
  FILTER_TYPES.EPIC,
  FILTER_TYPES.LABEL,
  FILTER_TYPES.ORGANIZATION_TEAMS,
  ISSUE_TYPES_KEY,
  ISSUE_STATES_KEY,
  STATE_TRANSITIONS_KEY
];

export const BUTTONS_KEYS = {
  ISSUE_TYPES: 'issueTypes',
  PROVIDER_STATES: 'providerStates',
  STATE_TRANSITION: 'stateTransition'
};

export const BUTTONS_TEXTS = {
  [PM_PROVIDERS.JIRA]: {
    [BUTTONS_KEYS.ISSUE_TYPES]: 'Select issue type',
    [BUTTONS_KEYS.PROVIDER_STATES]: 'Select state',
    [BUTTONS_KEYS.STATE_TRANSITION]: 'Select states'
  },
  [PM_PROVIDERS.AZURE_BOARDS]: {
    [BUTTONS_KEYS.ISSUE_TYPES]: 'Select Work Item type',
    [BUTTONS_KEYS.PROVIDER_STATES]: 'Select Azure state',
    [BUTTONS_KEYS.STATE_TRANSITION]: 'Select Azure states'
  }
};
